export default "__VITE_ASSET__CSNgAYfr__"